export default {
  NAVI: 'NAVI',
  MOBILE_NAVI: 'MOBILE_NAVI',
  BADGES: 'BADGES',
  CHALLENGES: 'CHALLENGES',
  STARTER_CRITERIA_COMPLETION: 'STARTER_CRITERIA_COMPLETION',
  PROJECTS: 'PROJECTS',
  PROJECT: 'PROJECT',
  PROJECT_FORM: 'PROJECT_FORM',
  MEMBERS: 'MEMBERS',
  MEMBER: 'MEMBER',
  BOOKINGS: 'BOOKINGS',
  EVENTS: 'EVENTS',
  WELCOME: 'WELCOME',
};
